import gql from 'graphql-tag';

import relatedMainDisplayObjectFragment from '../fragments/relatedMainDisplayObjectFragment';

export default gql`
  query relatedMainDisplayObjects(
    $dokkioObjectID: DokkioID!
  ) {
    relatedMainDisplayObjects(
      dokkioObjectID: $dokkioObjectID
    ) {
      ...relatedMainDisplayObjectFragment
    }
  }
  ${relatedMainDisplayObjectFragment}
`;
